var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M23.515 14.004a1.999 1.999 0 011.747.388h0l10.087 16.58c.284.473.35 1.017.225 1.513A1.994 1.994 0 0133.634 34h0-19.268a1.994 1.994 0 01-1.414-.586 1.994 1.994 0 01-.3-2.443h0l9.633-16.056a1.994 1.994 0 011.23-.911z", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" }),
            React.createElement("path", { d: "M24 28.4a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm0-9.4a1.2 1.2 0 011.2 1.2v6a1.2 1.2 0 11-2.4 0v-6A1.2 1.2 0 0124 19z", fill: "currentColor", fillRule: "nonzero" }))));
});
